import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AuthContextProvider } from './context/authContext';
import './axios';

ReactDOM.render(
  <React.StrictMode>
  <AuthContextProvider>
    <App />
  </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);